import React, { useState, useCallback, useEffect } from 'react';
import ShellRootContext, {
  ShellRootContextType,
  ShellRootUseContextReturnType
} from './ShellRootContext';

const ShellRootProvider = ({
  children,
  interfaces,
  ...props
}: ShellRootContextType) => {
  const { localization } = interfaces.v1;
  const [commonsGlobalTranslate, setCommonsGlobalTranslate] =
    useState<ShellRootUseContextReturnType['globalTranslate']>();

  useEffect(() => {
    localization
      ?.getGlobalTranslatorFunction?.()
      ?.then((t) => setCommonsGlobalTranslate(() => t));
  }, [localization]);

  const globalTranslate = useCallback<
    ShellRootUseContextReturnType['globalTranslate']
  >(
    (...args: Parameters<ShellRootUseContextReturnType['globalTranslate']>) => {
      return commonsGlobalTranslate?.(...args) || '';
    },
    [commonsGlobalTranslate]
  );

  return (
    <ShellRootContext.Provider
      value={{ ...props, globalTranslate, interfaces }}
    >
      {children}
    </ShellRootContext.Provider>
  );
};

export default ShellRootProvider;
